import {
  Button,
  ButtonGroup,
  Callout,
  Card,
  FormGroup,
  Intent,
} from '@blueprintjs/core';
import { WavelightAlgorithms } from '../../../../types';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { WavelightsState } from '../../types';
import { setAlgorithm, startAlgorithmCalculation } from '../../reducer';

const AlgoritmDesciption = {
  [WavelightAlgorithms.UNDEFINED]: 'Não selecionado',
  [WavelightAlgorithms.AVERAGE_OF_COLORS]: 'Média das cores',
  [WavelightAlgorithms.PPG_EXTRACTOR]: 'PPG Extractor',
};

interface AlgorithmCalculationProps {
  id: string;
}
const AlgorithmCalculation = ({ id }: AlgorithmCalculationProps) => {
  const dispatch = useAppDispatch();
  const {
    waveLightAlgorithms,
    selectedAlgorithm,
    algorithmCalculationLoading,
    algorithmCalculationResponse,
  }: WavelightsState = useAppSelector((state) => state.wavelight);

  // Start algorithm calculation upon current wavcelight ID
  const doAlgorithmCalculation = useCallback(() => {
    dispatch(
      startAlgorithmCalculation({
        id: id as string,
        algorithm: selectedAlgorithm,
      }),
    );
  }, [dispatch, id, selectedAlgorithm]);

  // State Controll of current Algorithm selection
  const onAlgorithmConfigurationSet = useCallback(
    (algorithm: WavelightAlgorithms) => {
      dispatch(setAlgorithm(algorithm));
    },
    [dispatch],
  );

  return (
    <Card>
      <FormGroup
        helperText={'Informe o algoritmo...'}
        intent={Intent.PRIMARY}
        label={'Algoritmo'}
        labelFor="algorithm-input"
        labelInfo={'(obrigatório)'}
      >
        <div className="bp5-html-select bp5-fill">
          <select
            value={selectedAlgorithm}
            onChange={(e) => {
              onAlgorithmConfigurationSet(
                WavelightAlgorithms[
                  String(e.target.value) as keyof typeof WavelightAlgorithms
                ],
              );
            }}
          >
            {waveLightAlgorithms.map((item) => {
              const wla =
                WavelightAlgorithms[
                  String(item) as keyof typeof WavelightAlgorithms
                ];
              return (
                <option key={item} value={item}>
                  {AlgoritmDesciption[wla]}
                </option>
              );
            })}
            -**
            <option value={WavelightAlgorithms.PPG_EXTRACTOR}>
              {AlgoritmDesciption[WavelightAlgorithms.PPG_EXTRACTOR]}
            </option>
          </select>
        </div>
      </FormGroup>
      {algorithmCalculationResponse && (
        <Callout>{algorithmCalculationResponse?.message}</Callout>
      )}
      <ButtonGroup>
        <Button
          icon="function"
          intent={Intent.PRIMARY}
          onClick={doAlgorithmCalculation}
          disabled={selectedAlgorithm === WavelightAlgorithms.UNDEFINED}
          loading={algorithmCalculationLoading}
        >
          Calcular
        </Button>
      </ButtonGroup>
    </Card>
  );
};

export default AlgorithmCalculation;
